import { render, staticRenderFns } from "./ImportModal.vue?vue&type=template&id=1f2b80e2&scoped=true&"
import script from "./ImportModal.vue?vue&type=script&lang=js&"
export * from "./ImportModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportModal.vue?vue&type=style&index=0&id=1f2b80e2&scoped=true&lang=css&"
import style1 from "./ImportModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b80e2",
  null
  
)

export default component.exports